var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.5C1 9.53765 3.46235 12 6.5 12C9.53765 12 12 9.53765 12 6.5C12 3.46235 9.53765 1 6.5 1C3.46235 1 1 3.46235 1 6.5Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04994 1.02747C7.04994 1.02747 8.69994 3.19997 8.69994 6.49997C8.69994 9.79997 7.04994 11.9725 7.04994 11.9725M5.94994 11.9725C5.94994 11.9725 4.29994 9.79997 4.29994 6.49997C4.29994 3.19997 5.94994 1.02747 5.94994 1.02747M1.34644 8.42497H11.6534M1.34644 4.57497H11.6534",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlob);
export default __webpack_public_path__ + "static/media/glob.104f372562c1a569b143cc092c54085c.svg";
export { ForwardRef as ReactComponent };